module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/reset-6046c91c7d80245cc450e5df2aec4272.svg";